import { memo, type ReactNode } from 'react'
import { clsx } from 'clsx'

import css from './AccountControls.module.scss'

import ThemeToggle from '@/components/ThemeToggle'
import UserMenu from '@/components/UserMenu'

import type { ControllerProps } from './AccountControls.controller'

export interface ViewProps extends ControllerProps {
  themeToggle?: ReactNode
  userMenu?: ReactNode
}

const View = memo(function AccountControlsView({ className, themeToggle, userMenu }: ViewProps) {
  return (
    <div className={clsx('AccountControls', css.root, className)}>
      {themeToggle ?? <ThemeToggle />}
      {userMenu ?? <UserMenu />}
    </div>
  )
})

View.displayName = 'AccountControls_View'

export default View
